import React, { useEffect, useRef } from "react";
import { useState } from "react";
import {
  Divider,
  IconButton,
  Tooltip,
  Select,
  MenuItem,
  OutlinedInput,
  Grid,
  Typography,
  Button,
  Box,
  Modal,
  Checkbox,
  Popper,
  ClickAwayListener,
  Paper,
  RadioGroup,
  Radio,
  Link,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import InfoIcon from "@mui/icons-material/Info";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { gql, useMutation, useQuery } from "@apollo/client";
import { Event, Launch, Phone, Settings } from "@mui/icons-material";
import EventTime from "./EventTime";
import { useNavigate, useParams } from "react-router-dom";
import { BpCheckedIcon, BpIcon } from "../../util/BPcheckbox";
import { ADD_EVENT, UPDATE_EVENT } from "../../graphql/mutations";
import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/lib/css/styles.css";
import "react-phone-number-input/style.css";
import AdditionalOptions from "./AdditionalOptions";
import { getInviteeQuestions } from "../../graphql/querys";
const options = [
  {
    value: "In Person Meeting",
    label: "In Person Meeting",
    image: "path/to/image1.png",
    icon: <LocationOnIcon />,
  },
  {
    value: "Phone Number",
    label: "Phone Number",
    image: "path/to/image1.png",
    icon: <Phone />,
  },
  // add more options with images here
];

const Cancel = styled((props) => (
  <Button disableRipple variant="outlined" {...props} />
))({
  color: "black",
  border: "none",
  height: "30px",
  "&:hover": {
    backgroundColor: "transparent",
    border: "none",
  },
});
const Next = styled((props) => <Button variant="outlined" {...props} />)({
  color: "rgb(0,105,255)",
  borderRadius: "30px",
  height: "30px",
});
const Next2 = styled((props) => (
  <Button variant="contained" style={{ background: "#d9bca9" }} {...props} />
))({
  color: "white",
  borderRadius: "30px",
  height: "30px",
  background: "#d9bca9",
  boxShadow: "none",
});
const EventTypes = (props) => {
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const section2Ref = useRef(null);
  const [event, setEvent] = useState(
    props.update ? props.update.find((obj) => parseInt(obj.id) == id) : null
  );
  const scrollToSection = (ref) => {
    setTimeout(() => {
      const section2 = document.getElementById(ref);
      const y = section2.getBoundingClientRect().top + window.pageYOffset - 150;
      section2.scrollIntoView(true);
    }, 100);
  };
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [colorPickerPopper, setColorPickerPopper] = useState(false);

  const handleCancel = () => {
    // perform the cancel action here
    window.location.href = "/app/events";
  };
  const handleNevermind = () => {
    // do nothing
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [colorPicker, setColorPicker] = useColor("hex", "#121212");
  const [selectedTab, setSelectedTab] = useState(!props.update && 0);
  const CancelModal = () => {
    return (
      <Modal
        open={showCancelModal}
        onClose={() => {
          setShowCancelModal(false);
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "10px",
            outline: "none",
            maxWidth: "400px",
          }}
        >
          <Typography variant="h5" sx={{ mb: 2 }}>
            Are you sure you want to cancel?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              style={{ background: "#d9bca9" }}
              onClick={() => setShowCancelModal(false)}
              sx={{ mr: 2 }}
            >
              Nevermind
            </Button>
            <Button variant="outlined" onClick={() => handleCancel()}>
              Yes
            </Button>
          </Box>
        </Box>
      </Modal>
    );
  };
  const [updateEvent] = useMutation(UPDATE_EVENT);
  const [addEvent] = useMutation(ADD_EVENT);
  const { loading, error, data, refetch } = useQuery(getInviteeQuestions, {
    variables: {
      eventId: parseInt(event?.id),
    },
  });
  const [location, setLocation] = useState(event ? event.locationType : "");
  const [link, setLink] = useState(event ? event.link : "");
  const [desc, setDesc] = useState(event ? event.desc : "");
  const [locationInput, setLocationInput] = useState(
    event ? event.location : ""
  );
  const [name, setName] = useState(event ? event.name : "");
  const [maxNum, setMaxNum] = useState(
    event?.maxInvitees ? event.maxInvitees : ""
  );
  const [phoneNumber, setPhoneNumber] = useState(
    event?.phoneNumber ? event.phoneNumber : ""
  );
  const [remaining, setRemaining] = useState(
    event?.showRemaining ? event.showRemaining : ""
  );
  const [color, setColor] = useState(event ? event.color : "red");
  const [value, setValue] = React.useState(event ? event.locationType : "");
  const originalLink = event ? event.link : "";
  const [hoveredColor, setHoveredColor] = useState(null);
  const [goforit, setGoForIt] = useState(false); // Inspired by blueprintjs
  const [additionalOptions, setAdditionalOptions] = useState(!!event);
  const handlePopper = (e) => {
    setAnchorEl(e.currentTarget);
    setColorPickerPopper(!colorPickerPopper);
    setColor(colorPicker?.hex);
  };
  function BpCheckbox(props) {
    return (
      <Checkbox
        sx={{
          padding: 0,
          "&:hover": { bgcolor: "transparent" },
        }}
        disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        checked={remaining}
        onChange={(e) => {
          setRemaining(!remaining);
        }}
        inputProps={{ "aria-label": "Checkbox demo" }}
        {...props}
      />
    );
  }
  const [updating, setUpdating] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = (propss) => {
    console.log(propss);
    if (event) {
      updateEvent({ variables: propss })
        .then((res) => {
          // window.location.href = "/app/events";
          setUpdating(true);
          setSelectedTab(null);
          setAdditionalOptions(true);

          refetch();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      addEvent({ variables: propss })
        .then((res) => {
          window.location.href = "/app/update/" + res.data.addEvent.id;
          setEvent(res.data.addEvent);
          setAdditionalOptions(true);
          refetch();
        })
        .catch((error) => {
          console.log(propss);
          console.log(error);
        });
    }
  };
  function invertColor(hexTripletColor) {
    var color = hexTripletColor;
    color = color.substring(1); // remove #
    color = parseInt(color, 16); // convert to integer
    color = 0xffffff ^ color; // invert three bytes
    color = color.toString(16); // convert to hex
    color = ("000000" + color).slice(-6); // pad with leading zeros
    color = "#" + color; // prepend #
    return color;
  }
  const [selectedValue, setSelectedValue] = React.useState(
    event ? !!event?.phoneNumberRadio : false
  );

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };
  const [bookingApproval, setBookingApproval] = useState(
    event?.bookingApproval ? event?.bookingApproval : 0
  );
  const controlProps = (item) => {
    return {
      checked: selectedValue.toString() == item.toString(),
      onChange: handleRadioChange,
      value: item,
      inputProps: { "aria-label": item },
    };
  };
  const [tooltip, setTooltipOpen] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const tooltipContent = [
    "Enter a name for your event.",
    "Enter a location for your event.",
    "Enter a description for your event.",
    "Enter an event link that describes your event.",
    "Choose a color for your event.",
    "Maximum number of invitees that can join at a time.",
    "Decide whether you want to approve any meeting automatically or wait for your approvation",
  ];
  const colorsMap = [
    "red",
    "yellow",
    "orange",
    "blue",
    "green",
    "violet",
    "pink",
    "magenta",
    "purple",
    "rainbow",
  ];
  const [colors, setColors] = useState([]);
  useEffect(() => {
    var e = [];
    colorsMap.map((val, ind) => {
      var push = { color: val };
      colorsMap.length - 1 == ind && (push.type = "rgb");
      e.push(push);
    });
    setColors(e);
    if (event) {
      setCompleted(true);
      var e = colors.slice();
      e[color.includes("rgb") ? "rgb" : color] = true;
    }
  }, []);
  const handleTooltipOpen = (i) => {
    var e = tooltip.slice();
    e[i] = true;
    setTooltipOpen(e);
  };

  const handleTooltipClose = (i) => {
    var e = tooltip.slice();
    e[i] = false;
    setTooltipOpen(e);
  };
  const [errors, setErrors] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  function sett(ee, n, news, loc) {
    if (n) {
      news[ee] = true;
      setGoForIt(loc);
    } else {
      news[ee] = false;
    }
    setErrors(news);
  }
  const [formCompleted, setCompleted] = useState(false);
  const validateForm = () => {
    // Check if all required inputs have a value
    if (
      !name ||
      !location ||
      !desc ||
      !link ||
      checkForExistingLink(link) ||
      (value === "In Person Meeting" && !locationInput) ||
      !color ||
      (props.group ? !maxNum : false)
    ) {
      var news = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ];
      sett(0, !name, news, "title");
      sett(1, !location, news, "loc");
      sett(2, value === "In Person Meeting" && !locationInput, news, "locType");
      sett(3, !desc, news, "desc");
      sett(4, !link || checkForExistingLink(link), news, "link");
      sett(5, !color, news, "color");
      props.group && sett(6, !maxNum, news, "maxNum");
      return false;
    }
    var news = [false, false, false, false, false, false, false, false, false];
    setErrors(news);
    return true;
  };
  const timeoutRef = useRef(null);
  const timeoutActiveRef = useRef(false);
  const notificationRef = useRef(null);
  useEffect(() => {
    if (updating && !timeoutActiveRef.current) {
      timeoutActiveRef.current = true;

      timeoutRef.current = setTimeout(() => {
        setUpdating(false);
        timeoutActiveRef.current = false;
      }, 2000);
    }

    return () => {
      clearTimeout(timeoutRef.current);
      timeoutActiveRef.current = false;
    };
  }, [updating]);

  useEffect(() => {
    if (notificationRef.current) {
      notificationRef.current.style.height = "0px";

      if (updating) {
        notificationRef.current.style.transition = "height 0.3s ease";
        notificationRef.current.style.height = "50px";
      } else {
        notificationRef.current.style.height = "0px";
      }
    }
  }, [updating]);
  const handleFormSubmit = (send) => {
    const isValid = validateForm();
    if (!isValid) {
      return;
    }
    setCompleted(true);
    setGoForIt(false);
    !send && setSelectedTab(1);
    send
      ? setCompleted(true)
      : setTimeout(() => {
          if (section2Ref) scrollToSection("section1");
        }, 10);
  };
  useEffect(() => {
    if (formCompleted) handleFormSubmit("e");
  }, [name, location, desc, link, locationInput, color, maxNum]);
  const handleChange = (setState) => (event) => {
    setState(event.target.value);
  };
  const handleChange2 = (setState, setState2) => (eventt) => {
    setState(eventt.target.value);
    setState2(eventt.target.value);
  };
  const checkForExistingLink = (link) => {
    for (let i = 0; i < props.data.length; i++) {
      if (props.data[i].link == link && link !== originalLink) {
        return true;
      }
    }
    return false;
  };
  return (
    <div className="addEventContainer" id="section1">
      {(additionalOptions || props.update) && (
        <div
          style={{
            height: "50px",
            padding: "20px 0",
            justifyContent: "flex-end",
            width: "100%",
            maxWidth: "900px",
            gap: "10px",
          }}
          className="flex align"
        >
          {props.update && (
            <Link
              href={"/" + props.details.url + "/events/" + event.link}
              style={{ cursor: "pointer" }}
            >
              view live page <Launch fontSize="12px" />
            </Link>
          )}
        </div>
      )}
      <div className="addEventBox">
        <div
          className="Top"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setSelectedTab(selectedTab !== 0 ? 0 : null);
          }}
        >
          <div>
            <div className="circle" style={{ backgroundColor: color }}></div>
          </div>
          <div>
            <h3 style={{ fontWeight: 400 }}>
              {name
                ? name + (location ? ", " + location : "")
                : "No Name Given"}
            </h3>
          </div>
        </div>
        <Divider />
        <div style={{ display: selectedTab !== 0 && "none" }}>
          <div className="form-control">
            <div>
              <Popper
                open={colorPickerPopper}
                anchorEl={anchorEl}
                placement="bottom-start"
              >
                {" "}
                <ClickAwayListener
                  onClickAway={(e) => {
                    e.stopPropagation();
                    setColorPickerPopper(false);
                  }}
                >
                  <>
                    <ColorPicker
                      width={300}
                      height={150}
                      color={colorPicker}
                      onChange={(e) => {
                        setColor(e.hex);
                        setColorPicker(e);
                      }}
                      hideHSV
                      hideRGB
                      hideHEX
                      dark
                    />
                    <Divider />
                    <Paper
                      style={{
                        height: "30px",
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "10px",
                      }}
                    >
                      <Button
                        style={{ background: "#d9bca9" }}
                        variant="contained"
                        onClick={() => setColorPickerPopper(false)}
                      >
                        Finish
                      </Button>
                    </Paper>
                  </>
                </ClickAwayListener>
              </Popper>
              <div style={{ display: "flex", alignItems: "center" }}>
                <h4 className="input-label">Event Name*</h4>

                <Tooltip
                  title={tooltipContent[0]}
                  placement="right"
                  open={tooltip[0]}
                  onClose={() => handleTooltipClose(0)}
                  onOpen={() => handleTooltipOpen(0)}
                  arrow
                  style={{ width: "10px", height: "10px" }}
                  classes={{
                    tooltip: "tooltip",
                    arrow: "tooltip-arrow",
                  }}
                >
                  <IconButton
                    aria-label="tooltip"
                    onClick={handleTooltipOpen}
                    onMouseEnter={handleTooltipOpen}
                    onMouseLeave={handleTooltipClose}
                    className="icon-button"
                    style={{ width: "15px", height: "15px" }}
                  >
                    <InfoIcon
                      className="icon"
                      style={{ width: "15px", height: "15px" }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
              <OutlinedInput
                onChange={handleChange(setName)}
                value={name}
                variant="outlined"
                error={errors[0]}
                id="title"
                style={{
                  width: "100%",
                  maxWidth: "500px",
                }}
              />
            </div>
            <div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <h4 className="input-label">Location*</h4>

                <Tooltip
                  title={tooltipContent[1]}
                  placement="right"
                  open={tooltip[1]}
                  onClose={() => handleTooltipClose(1)}
                  onOpen={() => handleTooltipOpen(1)}
                  arrow
                  style={{ width: "10px", height: "10px" }}
                  classes={{
                    tooltip: "tooltip",
                    arrow: "tooltip-arrow",
                  }}
                >
                  <IconButton
                    aria-label="tooltip"
                    onClick={handleTooltipOpen}
                    onMouseEnter={handleTooltipOpen}
                    onMouseLeave={handleTooltipClose}
                    className="icon-button"
                    style={{ width: "15px", height: "15px" }}
                  >
                    <InfoIcon
                      className="icon"
                      style={{ width: "15px", height: "15px" }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
              <Select
                value={value}
                variant="outlined"
                error={errors[1]}
                id="loc"
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  maxWidth: "500px",
                  height: "56px",
                }}
                onChange={handleChange2(setValue, setLocation)}
              >
                {options.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "56px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        height: "56px",
                        gap: "5%",
                      }}
                    >
                      {option.icon}
                      <h5 className="input-label">{option.label}</h5>
                    </div>
                  </MenuItem>
                ))}
              </Select>
              {/* <Popper
              placeholder="Enter phone number"
              value={phoneNumberInput}
              onChange={setPhoneNumberInput}
              open
              style={{ maxHeight: "300px" }}
            >
              <Paper
              style={{ maxHeight: "300px",overflow:'auto' }}>
                {Object.keys(countries).map((val) => (
                  <div style={{ width: "100%", height: "50px" }}>
                    {countries[val].name}
                  </div>
                ))}
              </Paper>
            </Popper> */}
              {value === "In Person Meeting" ? (
                <OutlinedInput
                  onChange={handleChange(setLocationInput)}
                  value={locationInput}
                  id="locType"
                  error={errors[2]}
                  variant="outlined"
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    marginTop: "20px",
                  }}
                />
              ) : value == "Phone Number" ? (
                <RadioGroup style={{ padding: "10px 0" }}>
                  <div className="flex align">
                    <div className="flex column">
                      <Typography>
                        <Radio {...controlProps("false")} />I will call my
                        invitee
                      </Typography>
                      <Typography
                        className="font2"
                        style={{ paddingLeft: "42px", maxWidth: "300px" }}
                      >
                        Calendly will require your invitee's phone number before
                        scheduling.
                      </Typography>
                    </div>
                  </div>
                  <div className="flex align">
                    <div className="flex column">
                      <Typography>
                        <Radio {...controlProps("true")} />
                        My invitee should call me
                      </Typography>
                      <Typography
                        className="font2"
                        style={{ paddingLeft: "42px", maxWidth: "300px" }}
                      >
                        Calendly will provide your number after the call has
                        been scheduled.
                      </Typography>
                      {selectedValue !== "true" && selectedValue !== true ? (
                        ""
                      ) : (
                        <OutlinedInput
                          onChange={handleChange(setPhoneNumber)}
                          value={phoneNumber}
                          id="phoneNumber"
                          error={errors[7]}
                          variant="outlined"
                          style={{
                            width: "100%",
                            maxWidth: "500px",
                            marginTop: "20px",
                          }}
                        />
                      )}
                    </div>
                  </div>
                </RadioGroup>
              ) : (
                ""
              )}
            </div>
            <div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <h4 className="input-label">Description*</h4>

                <Tooltip
                  title={tooltipContent[2]}
                  placement="right"
                  open={tooltip[2]}
                  onClose={() => handleTooltipClose(2)}
                  onOpen={() => handleTooltipOpen(2)}
                  arrow
                  style={{ width: "10px", height: "10px" }}
                  classes={{
                    tooltip: "tooltip",
                    arrow: "tooltip-arrow",
                  }}
                >
                  <IconButton
                    aria-label="tooltip"
                    onClick={handleTooltipOpen}
                    onMouseEnter={handleTooltipOpen}
                    onMouseLeave={handleTooltipClose}
                    className="icon-button"
                    style={{ width: "15px", height: "15px" }}
                  >
                    <InfoIcon
                      className="icon"
                      style={{ width: "15px", height: "15px" }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
              <OutlinedInput
                onChange={handleChange(setDesc)}
                value={desc}
                id="desc"
                error={errors[3]}
                variant="outlined"
                style={{
                  width: "100%",
                  maxWidth: "500px",
                }}
                multiline
                rows={6}
              />
            </div>
            <div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <h4 className="input-label">Event Link*</h4>

                <Tooltip
                  title={tooltipContent[3]}
                  placement="right"
                  open={tooltip[3]}
                  onClose={() => handleTooltipClose(3)}
                  onOpen={() => handleTooltipOpen(3)}
                  arrow
                  style={{ width: "10px", height: "10px" }}
                  classes={{
                    tooltip: "tooltip",
                    arrow: "tooltip-arrow",
                  }}
                >
                  <IconButton
                    aria-label="tooltip"
                    onClick={handleTooltipOpen}
                    onMouseEnter={handleTooltipOpen}
                    onMouseLeave={handleTooltipClose}
                    className="icon-button"
                    style={{ width: "15px", height: "15px" }}
                  >
                    <InfoIcon
                      className="icon"
                      style={{ width: "15px", height: "15px" }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", gap: "5px" }}
              >
                <OutlinedInput
                  onChange={handleChange(setLink)}
                  value={link}
                  id="link"
                  variant="outlined"
                  error={errors[4]}
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                  }}
                  aria-describedby="component-error-text"
                />

                {checkForExistingLink(link) && errors[4] && (
                  <Typography
                    variant="caption"
                    color="error"
                    id="component-error-text"
                  >
                    Please enter a different link.
                  </Typography>
                )}
              </div>
            </div>
            {(props.group || event?.eventType == "group") && (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "5px" }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <h4 className="input-label">
                    Maximum number of invitee spots*
                  </h4>

                  <Tooltip
                    title={tooltipContent[5]}
                    placement="right"
                    open={tooltip[5]}
                    onClose={() => handleTooltipClose(5)}
                    onOpen={() => handleTooltipOpen(5)}
                    arrow
                    style={{ width: "10px", height: "10px" }}
                    classes={{
                      tooltip: "tooltip",
                      arrow: "tooltip-arrow",
                    }}
                  >
                    <IconButton
                      aria-label="tooltip"
                      onClick={handleTooltipOpen}
                      onMouseEnter={handleTooltipOpen}
                      onMouseLeave={handleTooltipClose}
                      className="icon-button"
                      style={{ width: "15px", height: "15px" }}
                    >
                      <InfoIcon
                        className="icon"
                        style={{ width: "15px", height: "15px" }}
                      />
                    </IconButton>
                  </Tooltip>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <OutlinedInput
                    disabled={!!props.update}
                    onChange={handleChange(setMaxNum)}
                    value={maxNum}
                    id="maxNum"
                    variant="outlined"
                    error={errors[6]}
                    inputProps={{ min: 0, style: { textAlign: "center" } }}
                    style={{
                      width: "100%",
                      maxWidth: "65px",
                      height: "60px",
                    }}
                    aria-describedby="component-error-text"
                  />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <BpCheckbox
                      disableFocusRipple
                      disableTouchRipple
                      disableRipple
                      size="small"
                      checked={remaining}
                    />
                    <Typography>
                      Display remaining slots on booking page.
                    </Typography>
                  </div>
                </div>
              </div>
            )}
            <div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <h4
                  className="input-label"
                  style={{ border: errors[5] && "1px solid red" }}
                >
                  Color*
                </h4>

                <Tooltip
                  title={tooltipContent[4]}
                  placement="right"
                  open={tooltip[4]}
                  onClose={() => handleTooltipClose(4)}
                  onOpen={() => handleTooltipOpen(4)}
                  arrow
                  style={{ width: "10px", height: "10px" }}
                  classes={{
                    tooltip: "tooltip",
                    arrow: "tooltip-arrow",
                  }}
                >
                  <IconButton
                    aria-label="tooltip"
                    onClick={handleTooltipOpen}
                    onMouseEnter={handleTooltipOpen}
                    onMouseLeave={handleTooltipClose}
                    className="icon-button"
                    style={{ width: "15px", height: "15px" }}
                  >
                    <InfoIcon
                      className="icon"
                      style={{ width: "15px", height: "15px" }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
              <Grid
                container
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  display: "flex",
                  gap: "10px",
                }}
              >
                {colors.map((val, ind) => {
                  var displayColor = val["color"];
                  return (
                    <Grid
                      item
                      key={ind}
                      xs={1.9}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        minWidth: "40px",
                        maxWidth: "40px",
                        height: "70px",
                        gap: "3px",
                      }}
                      onClick={(e) =>
                        val["type"] ? handlePopper(e) : setColor(displayColor)
                      }
                    >
                      <div
                        className="circle displayFlex align justify"
                        onMouseEnter={() => setHoveredColor(displayColor)}
                        onMouseLeave={() => setHoveredColor(null)}
                        style={{
                          color: val["type"]
                            ? invertColor(colorPicker?.hex)
                            : "transparent",
                          backgroundColor: val["type"]
                            ? colorPicker?.hex
                            : displayColor,
                          maxWidth: "40px",
                          minWidth: "40px",
                          maxHeight: "40px",
                          minHeight: "40px",
                          height: "40px",
                          cursor: "pointer",
                          boxShadow:
                            "0px " +
                            ((
                              val["type"]
                                ? color == colorPicker?.hex
                                : color == displayColor
                            )
                              ? 1
                              : 0) +
                            "px " +
                            ((
                              val["type"]
                                ? color == colorPicker?.hex
                                : color == displayColor
                            )
                              ? 8
                              : 0) +
                            "px " +
                            (val["type"] ? colorPicker?.hex : displayColor),
                        }}
                      >
                        RGB
                      </div>{" "}
                      <Typography>
                        {hoveredColor === val.color && val.color !== "rgb"
                          ? val.color
                          : ""}
                      </Typography>
                    </Grid>
                  );
                })}
              </Grid>
            </div>
            <div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <h4 className="input-label">Booking Approval*</h4>

                <Tooltip
                  title={tooltipContent[6]}
                  placement="right"
                  open={tooltip[6]}
                  onClose={() => handleTooltipClose(6)}
                  onOpen={() => handleTooltipOpen(6)}
                  arrow
                  style={{ width: "10px", height: "10px" }}
                  classes={{
                    tooltip: "tooltip",
                    arrow: "tooltip-arrow",
                  }}
                >
                  <IconButton
                    aria-label="tooltip"
                    onClick={handleTooltipOpen}
                    onMouseEnter={handleTooltipOpen}
                    onMouseLeave={handleTooltipClose}
                    className="icon-button"
                    style={{ width: "15px", height: "15px" }}
                  >
                    <InfoIcon
                      className="icon"
                      style={{ width: "15px", height: "15px" }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
              <Grid
                container
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  display: "flex",
                  gap: "10px",
                }}
              >
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue={0}
                    value={bookingApproval}
                    name="radio-buttons-group"
                  >
                    <FormControlLabel
                      value={0}
                      onClick={()=>setBookingApproval(0)}
                      control={<Radio />}
                      label="Approve Automatically"
                    />
                    <FormControlLabel
                      value={1}
                      onClick={()=>setBookingApproval(1)}
                      control={<Radio />}
                      label="Send to pending list"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </div>
          </div>
          <Divider />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "20px",
            }}
          >
            <Cancel onClick={() => setShowCancelModal(true)}>Cancel</Cancel>
            <CancelModal
              isOpen={showCancelModal}
              onCancel={handleCancel}
              onNevermind={handleNevermind}
            />
            {event ? (
              <Next2
                onClick={() => {
                  handleSubmit({
                    eventId: parseInt(id),
                    title: name,
                    location,
                    desc,
                    color,
                    phoneNumber,
                    phoneNumberRadio:
                      selectedValue == "true" || selectedValue == true,
                    link,
                    location: locationInput,
                    locationType: location,
                    bookingApproval:bookingApproval
                  });
                }}
              >
                Save & Close
              </Next2>
            ) : (
              <Next
                onClick={() => {
                  handleFormSubmit();
                }}
              >
                Next
              </Next>
            )}
          </div>
        </div>
      </div>
      {formCompleted ? (
        <EventTime
          setShow={setShow}
          id={id}
          title={name}
          locationType={location}
          color={color}
          desc={desc}
          link={link}
          maxNum={maxNum}
          remaining={remaining}
          group={props.group || event?.eventType == "group"}
          location={locationInput}
          handleSubmit={handleSubmit}
          goforit={goforit}
          setGoForIt={setGoForIt}
          handle={scrollToSection}
          selectedTab={selectedTab}
          currentUser={props.currentUser}
          decodedToken={props.decodedToken}
          setUpdating={setUpdating}
          bookingApproval={bookingApproval}
          setSelectedTab={setSelectedTab}
          phoneNumber={phoneNumber}
          radio={selectedValue == "true" || selectedValue == true}
          update={event ? event : ""}
        />
      ) : (
        ""
      )}
      {(additionalOptions || props.update) && (
        <AdditionalOptions
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          eventId={event?.id}
          data={data}
          refetch={refetch}
          error={error}
          loading={loading}
          phoneNumber={
            !(selectedValue == "true" || selectedValue == true) &&
            event?.locationType == "Phone Number"
          }
        />
      )}{" "}
      {updating && (
        <div ref={notificationRef} className="notification">
          Changes Saved!
        </div>
      )}
    </div>
  );
};
export default EventTypes;
